let ChromaticVert = `
attribute vec4 aPosition;

varying vec2 v_uv;

void main() {
    // calculate uvs
    v_uv = aPosition.xy;
    v_uv.y *= -1.0;
    v_uv.x = v_uv.x * 0.5 + 0.5;
    v_uv.y = v_uv.y * 0.5 + 0.5;

    // set position
    gl_Position = aPosition;
}
`;

let ChromaticFrag = `
precision mediump float;

uniform sampler2D u_mainTex;
uniform float u_strength;
uniform float u_time;
uniform float u_op;

varying vec2 v_uv;

void main() {
    vec2 toCenter = vec2(0.5,0.5)-v_uv;

    // sample the texture three times with different offsets from the center for each color channel to achieve a chromatic abberation effect
    float r = texture2D(u_mainTex, v_uv+toCenter*u_strength*0.01).r;
    float g = texture2D(u_mainTex, v_uv+toCenter*u_strength*0.02).g;
    float b = texture2D(u_mainTex, v_uv+toCenter*u_strength*0.03).b;
    gl_FragColor = vec4(r,g,b,u_op); // interesting changing the opacity
}
`;


module.exports = {
    ChromaticFrag: ChromaticFrag,
    ChromaticVert: ChromaticVert
}
